@if (helpentryId > 0) {
  <div id="submodule-helpentries-roles" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel -->
      <h2>{{ 'GENERAL.ROLES' | translate }}</h2>
      <!-- Toolbar -->
      @if (!editMode) {
        <phscw-toolbar
          componentIdentifier="globalHelpRoles"
          [componentConnection]="$any(this)"
          [buttonAdd]="true">
        </phscw-toolbar>
      }
    </div>
    <!-- Grid -->
    @if (!editMode) {
      <phscw-grid
        #gridGlobalHelpRoles
        [gridId]="gridId"
        [simpleGrid]="true"
        [gridData]="data"
        [gridColumns]="gridColumns"
        [gridDisplayedColumns]="gridDisplayedColumns">
      </phscw-grid>
    }
    <!-- Funktion um weitere Einträge zu laden -->
    @if (!editMode) {
      <phscw-grid-load-more
        [gridId]="gridId"
        [enabled]="loadMoreEnabled"
        [visible]="loadMoreVisible"
        [gridPageCounter]="gridPage">
      </phscw-grid-load-more>
    }
    <!-- Formular (für EditMode) -->
    @if (editMode) {
      <form #globalHelpRolesForm="ngForm" (ngSubmit)="clickSubmit()">
        <div>&nbsp;</div>
        <!-- Eingabefelder -->
        <input type="hidden" name="helpentry_id" [(ngModel)]="helpentryId" />
        <phscw-input-text
          [editMode]="editMode"
          label="{{ 'GENERAL.ID' | translate }}"
          name="id"
          inputId="id"
          [(ngModel)]="roleId"
        [disabled]="true"></phscw-input-text>
        @if (!newRole) {
          <phscw-input-text
            [editMode]="editMode"
            label="{{ 'GENERAL.LABEL' | translate }}"
            name="name"
            inputId="name"
            [(ngModel)]="roleName"
          [disabled]="true"></phscw-input-text>
        }
        @if (newRole) {
          <phscw-input-select
            [editMode]="editMode"
            label="{{ 'GENERAL.ROLE' | translate }}"
            name="role_id"
            inputId="role_id"
            [selectData]="unusedRoles"
          [(ngModel)]="roleId"></phscw-input-select>
        }
        <phscw-input-single-checkbox
          [editMode]="editMode"
          label="{{ 'GENERAL.READ' | translate }}"
          name="display_right"
          inputId="display_right"
          [(ngModel)]="dataItem.display_right"
        [showCheckbox]="true"></phscw-input-single-checkbox>
        <div class="cw-horizontalline"></div>
        <div>
          <phscw-output-timestamp
            class="cw-flex-row"
            label="{{ 'GENERAL.CREATION' | translate }}"
            [timestamp]="dataItem.create_date"
          additional="{{ dataItem.create_user }}"></phscw-output-timestamp>
          <phscw-output-timestamp
            class="cw-flex-row"
            label="{{ 'GENERAL.ALTERATION' | translate }}"
            [timestamp]="dataItem.edit_date"
          additional="{{ dataItem.edit_user }}"></phscw-output-timestamp>
          <phscw-output-timestamp
            class="cw-flex-row"
            label="{{ 'GENERAL.DELETION' | translate }}"
            [timestamp]="$any(dataItem.delete_date)"
          additional="{{ dataItem.delete_user }}"></phscw-output-timestamp>
        </div>
        <!-- Buttons Submit & Cancel (für EditMode) -->
        @if (editMode) {
          <div class="cw-button-wrapper">
            <button
              mat-raised-button
              color="accent"
              type="submit"
              [disabled]="!globalHelpRolesForm.form.valid || roleId === 0">
              {{ 'GENERAL.SAVE' | translate }}
            </button>
            <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
              {{ 'GENERAL.CANCEL' | translate }}
            </button>
          </div>
        }
      </form>
    }
  </div>
}
